'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var react = require('react');
var SystemIcon = require('../SystemIcon/SystemIcon.js');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');

const AvatarContent = ({ size = 'md', name, imgUrl, isMonogram, avatarStyle })=>{
    const [imageLoadError, setImageLoadError] = react.useState(false);
    const firstChar = name === null || name === void 0 ? void 0 : name.slice(0, 1);
    const handleImageError = ()=>setImageLoadError(true);
    if (imgUrl && !imageLoadError) {
        return jsxRuntime.jsx("img", {
            src: imgUrl,
            alt: "",
            width: 80,
            height: 80,
            className: "h-full w-full object-cover",
            "data-testid": "design-system-avatar--image",
            onError: handleImageError
        });
    }
    if (isMonogram) {
        return jsxRuntime.jsx(Typography, {
            variant: avatarStyle[size].char,
            className: "cursor-default select-none text-w-white",
            children: firstChar
        });
    }
    return jsxRuntime.jsx(SystemIcon, {
        name: "large_user_image_avatar",
        className: "h-full w-full",
        testId: "design-system-avatar--default-image"
    });
};
/**
 * Avatar 컴포넌트는 사용자의 프로필 이미지, 모노그램, 또는 기본 아이콘을 표시합니다.
 * @component
 * @param {Object} props
 * @param {AvatarSize} [props.size='md'] - 아바타 크기 ('sm' | 'md' | 'lg' | 'xl')
 * @param {string} [props.name] - 이미지가 없을 경우 표시할 사용자 이름 (이니셜로 표시됨)
 * @param {string} [props.imgUrl] - 아바타 이미지 URL
 * @param {boolean} [props.isEditable=false] - 아바타 수정 아이콘 여부
 * @param {() => void} [props.onClick] - 아바타 클릭 시 실행될 콜백 함수
 * @returns {JSX.Element} Avatar component
 * @example
 * // Basic usage
 * <Avatar name="John Doe" size="md" />
 *
 * // With image
 * <Avatar imgUrl="/path/to/image.jpg" size="lg" />
 *
 * // Editable avatar
 * <Avatar name="John Doe" isEditable={true} onClick={() => handleEdit()} />
 */ const Avatar = ({ size = 'md', name, imgUrl, isEditable = false, onClick })=>{
    const isMonogram = !imgUrl && !!name;
    const avatarStyle = {
        sm: {
            container: 'size-[22px]',
            char: 'caption1',
            editButton: 'hidden'
        },
        md: {
            container: 'size-8',
            char: 'body1',
            editButton: 'size-4'
        },
        lg: {
            container: 'size-12',
            char: 'title3',
            editButton: 'size-5'
        },
        xl: {
            container: 'size-20',
            char: 'title2',
            editButton: 'size-6'
        }
    };
    return jsxRuntime.jsxs(Box, {
        className: tailwindMerge.twMerge('relative z-0 h-fit w-fit', isEditable && 'cursor-pointer'),
        onClick: onClick,
        children: [
            jsxRuntime.jsx(Box, {
                "data-testid": "design-system-avatar--container",
                className: tailwindMerge.twMerge(avatarStyle[size].container, 'flex items-center justify-center overflow-hidden rounded-full border border-w-gray-200', isMonogram && 'bg-primary'),
                children: jsxRuntime.jsx(AvatarContent, {
                    size: size,
                    name: name,
                    imgUrl: imgUrl,
                    isMonogram: isMonogram,
                    avatarStyle: avatarStyle
                })
            }),
            !isMonogram && isEditable && jsxRuntime.jsx(Box, {
                className: tailwindMerge.twMerge('absolute -right-0.5 bottom-0 z-10 flex items-center justify-center rounded-full bg-w-white shadow-graysmall', avatarStyle[size].editButton),
                "data-testid": "design-system-avatar--edit-button",
                children: jsxRuntime.jsx(SystemIcon, {
                    name: "small_camera",
                    solid: true,
                    className: tailwindMerge.twJoin(size === 'md' && 'size-3'),
                    testId: "design-system-avatar--edit-button-icon"
                })
            })
        ]
    });
};
var Avatar$1 = react.memo(Avatar);

module.exports = Avatar$1;
